import { render, staticRenderFns } from "./ListPrivilegeCategory.vue?vue&type=template&id=1fb1b232&scoped=true"
import script from "./ListPrivilegeCategory.vue?vue&type=script&lang=js"
export * from "./ListPrivilegeCategory.vue?vue&type=script&lang=js"
import style0 from "./ListPrivilegeCategory.vue?vue&type=style&index=0&id=1fb1b232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1b232",
  null
  
)

export default component.exports